<template>
  <div class="all">
    <div class="mask"></div>
    <div class="popup">
      <div class="popup-box">
        <!-- <div class="title">Reward</div> -->
        <div class="content">
          <!-- 名称 -->
          <div class="content-desc longTouch">
            {{ popup_info.name || "Yuli Character EXP Material" }}
          </div>

          <!-- 图标 -->
          <div class="content-icon">
            <img
              class="propIcon"
              :src="popup_info.img_url || 'https://www.yuliverse.com/pre/images/xmas/1.png'"
            />
            <img
              class="yiny"
              :src="require('@/assets/images/YuliApp/weeklyTask/store_wupin_yiny.svg')"
            />
          </div>

          <!-- Owned -->
          <div class="content-owned">Owned: {{ popup_info.count || 0 }}</div>

          <!-- 描述 -->
          <div class="content-moreDesc longTouch">
            {{ popup_info.description || "Character EXP material.Gives 100 EXP." }}
          </div>
          <div class="content-button" @click="handleClose">Quit</div>
        </div>
      </div>
      <!-- 弹窗按钮 -->
    </div>
  </div>
</template>
<script>
import { onBeforeMount, onMounted, ref } from "vue";
import { REWARD_TYPE } from "@/constants/enums";
export default {
  props: {
    stateIconUrl: {
      type: String,
      default: require("@/assets/images/YuliApp/weeklyTask/btn_task_yes.svg"),
    },
    iconUrl: {
      type: String,
      default: require("@/assets/images/YuliApp/weeklyTask/goods_icon_exp@2x.png"),
    },
    cur_props_owned: {
      type: Number,
      default: 2,
    },
    state: {
      type: Number,
      default: 3,
    },
    cur_popup_info: {
      type: Object,
      default: null,
    },
  },
  watch: {
    cur_popup_info: {
      handler(value) {
        if (!value) {
          return;
        }

        this.popup_info = value;
        // this.handleOwnUpdate();
      },
      immediate: true,
      deep: true,
    },
    // cur_props_owned: {
    //   handler(value) {
    //     this.Owned = value;
    //   },
    //   immediate: true,
    //   deep: true,
    // },
  },
  setup(props, ctx) {
    const { state } = props;
    const REWARD_STATE = ref(REWARD_TYPE);
    const popup_info = ref(null);
    const Owned = ref(0);

    /**
     * 处理关闭
     */
    const handleClose = () => {
      ctx.emit("close", false, state);
    };

    /**
     * 领取奖励成功之后立即奖励详情还没来得及更新的情况
     */
    const handleOwnUpdate = (data) => {
      const prop_id = localStorage.getItem("prop_id");
      const current_holding = localStorage.getItem("current_holding");
      if (
        popup_info.value.prop_id === prop_id &&
        popup_info.value.current_holding < current_holding
      ) {
        popup_info.value.current_holding = current_holding;
      }
    };
    return {
      handleClose,
      REWARD_STATE,
      popup_info,
      Owned,
      handleOwnUpdate,
    };
  },
};
</script>

<style lang="less" scoped>
//阻止长按操作
.longTouch {
  -webkit-touch-callout: none; /*系统默认菜单被禁用*/
  -webkit-user-select: none; /*webkit浏览器*/
  -khtml-user-select: none; /*早期浏览器*/
  -moz-user-select: none; /*火狐*/
  -ms-user-select: none; /*IE10*/
  user-select: none;
}

.all {
  width: 100%;
  height: 100%;
  margin-top: -60px;
  overflow: hidden;
  position: absolute;
  bottom: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  z-index: 999;

  .mask {
    position: absolute;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.8);
    top: 0;
    left: 0;
  }
  .popup {
    position: absolute;
    z-index: 9999;
    width: 100%;
    height: 264px;
    top: 20%;
    text-align: center;
    &-box {
      display: flex;
      align-items: center;
      flex-direction: column;
      .title {
        width: 348.06px;
        height: 41.09px;
        // background: url("~@/assets/images/YuliApp/weeklyTask/popup_top_img@2x.png")
        //   no-repeat top left;
        background-size: 100% 100%;

        color: rgba(184, 191, 217, 1);
        font-size: 18px;
        font-weight: 700;
        font-family: "PingFang SC";
        text-align: center;
        line-height: 41px;
      }
      .content {
        position: relative;
        width: 350px;
        min-height: 390px;
        margin: -1px 0 0 1.1px;
        padding-top: 22px;
        display: flex;
        align-items: center;
        flex-direction: column;
        background: url("~@/assets/images/YuliApp/kudasaiChristmas/popup_bg.png") no-repeat top left;
        background-color: #fff;
        background-size: 100% 100%;

        &-icon {
          position: relative;
          width: 120px;
          height: 120px;
          margin-top: 25px;
          .propIcon {
            width: 100%;
            height: 100%;
          }
          .yiny {
            position: absolute;
            bottom: -15px;
            left: 0;
            width: 131px;
            height: 23px;
          }
        }
        &-desc {
          color: rgb(72, 76, 88);
          font-size: 16px;
          font-size: 18px;
          font-weight: 500;
          text-align: center;
          line-height: 19.2px;
          // margin-bottom: 22px;
        }
        &-owned {
          color: rgba(46, 46, 46, 1);
          font-size: 15px;
          font-weight: 500;
          text-align: left;
          line-height: 21.6px;
          margin-bottom: 25px;
          margin-top: 16px;
        }
        &-moreDesc {
          width: 240.5px;
          color: rgba(101, 104, 106, 1);
          font-size: 15px;
          font-weight: 400;
          font-family: "PingFang HK";
          text-align: center;
          line-height: 16.8px;
        }
        &-state {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 307px;
          height: 60px;
          opacity: 1;

          background: linear-gradient(
            90deg,
            rgba(35, 73, 81, 0) 0%,
            rgba(35, 73, 81, 1) 37%,
            rgba(35, 73, 81, 1) 64%,
            rgba(35, 73, 81, 0) 100%
          );
          color: rgba(92, 215, 209, 1);

          font-size: 22px;
          font-weight: 500;
          font-family: "PingFang HK";
          text-align: left;
          line-height: 26.4px;
          img {
            width: 38px;
            height: 38px;
            margin-right: 4px;
            margin-top: -4px;
          }
        }
        .state2 {
          background: linear-gradient(
            90deg,
            rgba(35, 73, 81, 0) 0%,
            rgba(35, 73, 81, 1) 37%,
            rgba(35, 73, 81, 1) 64%,
            rgba(35, 73, 81, 0) 100%
          );
          color: rgba(92, 215, 209, 1);
          // margin-bottom: 10px;
        }
        .state0 {
          background: linear-gradient(
            90deg,
            rgba(27, 31, 40, 0) 0%,
            rgba(27, 31, 40, 1) 26%,
            rgba(27, 31, 40, 1) 76%,
            rgba(27, 31, 40, 0) 100%
          );
          color: rgba(231, 218, 109, 1);
          // margin-bottom: 10px;
          img {
            margin-right: 8.5px;
          }
        }
        &-button {
          position: absolute;
          bottom: 12px;
          width: 128px;
          height: 38px;
          border-radius: 37px;
          opacity: 1;
          background: rgb(79, 83, 86);
          color: #fff;
          font-size: 16px;
          line-height: 38px;
        }
      }
      .bottomIcon {
        position: relative;
        margin: -2px 0 0 1px;
        width: 320px;
        height: 20px;
        img {
          position: absolute;
          left: 0;
          top: 0;
          width: 100%;
          height: 100%;
        }
      }
    }
  }
}
</style>
